import * as React from "react";
const SvgIcFilePpt = props => <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1 5a4 4 0 0 1 4-4h22a4 4 0 0 1 4 4v22a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4V5Z" fill="#EBAD00" /><path fill="#fff" d="M5 9h22v14H5z" /></svg>;
export default SvgIcFilePpt;